import script from "./resident-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./resident-modal.vue?vue&type=script&setup=true&lang=js"

import "./resident-modal.vue?vue&type=style&index=0&id=4849a1cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4849a1cf"]])

export default __exports__